const FAQS = [
  {
    id: 1,
    q: '99漫画的漫画资源是免费的吗？',
    a: '99漫画平台上所有漫画作品均为免费阅读，无需充值会员或付费解锁。我们致力于为漫迷提供韩漫、日漫、国漫全集大全的免费阅读体验，全部漫画资源均可通过下拉式阅读方式免费浏览。平台通过合规广告运营维持服务，不会以任何形式向读者收取费用。',
  },
  {
    id: 2,
    q: '99漫画和4399漫画网有什么关系？区别在哪？',
    a: '99漫画是独立运营的漫画阅读平台，在内容覆盖与阅读体验上与4399漫画网有相似之处。相比而言，99漫画更专注于下拉式阅读体验，同时覆盖韩漫、日漫、国漫三大品类。我们的更新速度更快，漫画分类更精细，收藏追更功能也更完善。',
  },
  {
    id: 3,
    q: '如何使用下拉式阅读和追更收藏功能？',
    a: '下拉式阅读是99漫画的核心特色：打开任意漫画章节，向下滑动即可连续阅读，无需点击翻页按钮。追更收藏同样简单——在漫画详情页点击收藏按钮，该漫画更新时系统会自动提醒您。您可以在个人书架中统一管理所有收藏的漫画。',
  },
  {
    id: 4,
    q: '平台上的漫画多久更新一次？支持哪些设备阅读？',
    a: '99漫画每日同步更新热门连载漫画，通常在每日06:00完成最新章节的更新上线。平台全面支持电脑、平板和手机多端阅读，阅读进度和收藏列表云端自动同步。无论在哪种设备上，都能享受流畅的下拉式阅读体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600">
            关于99漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}